/**
 * Copyright © Veeam Software Group GmbH.
 */

import { createContext } from 'react';

import type { EditUserProfileStore } from './edit-user-profile-store';

export const EditUserProfileStoreContext = createContext<EditUserProfileStore>({} as EditUserProfileStore);
